import AuditTemplateBlockOverview from "Components/Pages/AuditTemplateBlockOverview/AuditTemplateBlockOverview";
import AuditTemplateDetailView from "Components/Pages/AuditTemplateDetailView/AuditTemplateDetailView";
import ChecklistTemplateDetailView from "Components/Pages/ChecklistTemplateDetailView/ChecklistTemplateDetailView";
import ChecklistTemplateBlockOverview from "Components/Pages/CheckTemplateBlockOverview/ChecklistTemplateBlockOverview";
import TaskTemplateBlockOverview from "Components/Pages/TaskTemplateBlockOverview/TaskTemplateBlockOverview";
import TaskTemplateDetailView from "Components/Pages/TaskTemplateDetailView/TaskTemplateDetailView";
import TaskTemplateListOverview from "Components/Pages/TaskTemplateListOverview/TaskTemplateListOverview";
import * as React from "react";
import { Redirect, Route, Switch } from "react-router";
import LoginComponent from "../Components/Authentication/LoginComponent";
import LogoutComponent from "../Components/Authentication/LogoutComponent";
import RedirectToCMS from "../Components/Redirect/RedirectToCMS";

const Routes: React.FunctionComponent = () => {
    return (
        <>
            <Switch>
                <Route path="/externallogin" render={(props) => (<LoginComponent {...props} />)} exact={true} />
                <Route path="/logout" render={(props) => (<LogoutComponent {...props} />)} exact={true} />
                <Route path="/home" render={(props) => (<RedirectToCMS {...props} externalPath="" />)} exact={true} />
                <Route path="/tasktemplates" component={TaskTemplateBlockOverview} exact={true} />
                <Route path="/tasktemplates/list/arrange" component={TaskTemplateListOverview} exact={true} />
                <Route path="/tasktemplates/:taskTemplateId" component={TaskTemplateDetailView} exact={true} />
                <Route path="/checklisttemplates" component={ChecklistTemplateBlockOverview} exact={true} />
                <Route path="/checklisttemplates/:checklistTemplateId" component={ChecklistTemplateDetailView} exact={true} />
                <Route path="/audittemplates" component={AuditTemplateBlockOverview} exact={true} />
                <Route path="/audittemplates/:auditTemplateId" component={AuditTemplateDetailView} exact={true} />
                <Route path="/actions" render={(props) => (<RedirectToCMS {...props} externalPath="/constructor/actions" />)} exact={true} />
                <Route path="/companies" render={(props) => (<RedirectToCMS {...props} externalPath="/companies" />)} exact={true} />
                <Redirect from="*" to="/tasktemplates" exact={true} />
            </Switch>
        </>
    );
};

export default Routes;


// WEBPACK FOOTER //
// ./src/Routes/Routes.tsx